module.exports = __webpack_public_path__ + "public/SiteIcons/emailVerifi.svg?aa7bb7c6";